import apiRequest from './apiRequest';
import type { MotionEditorJobListItem } from './postSceneObjectMotionEdit';

export type MotionEditorHistoryResponse = {
  /** All motion-editor jobs for this timeline slot, newest first. */
  jobs: MotionEditorJobListItem[];
};

export default async function getSceneObjectMotionEdits(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<MotionEditorHistoryResponse>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/motionEdits`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
